
/* ============================== src/components/discussion/constants.js ============================== */
export const REACTION_PALETTE = ["👍", "❤️", "🔥", "😂", "😮", "😢", "✅"];

export const SORT_OPTIONS = [
  { id: "new", label: "Новые" },
  { id: "old", label: "Старые" },
  { id: "popular", label: "Популярные" },
];
